import _ from 'lodash'
import moment from 'moment/min/moment-with-locales'

// PUBLIC METHODS
function getClassDisplayTime({
  date,
  fromTime,
  toTime,
  timeFormat = 'LT',
  dateFormat = 'L',
}) {
  return _.join(
    _.compact([
      // time
      _.join(
        _.map(
          // prevent duplicate times
          _.uniq(_.compact([fromTime, toTime])),
          (time) => moment(time).format(timeFormat),
        ),
        ' - ',
      ),
      // date
      date && moment(date).format(dateFormat),
    ]),
    ' ',
  )
}

export default {
  getClassDisplayTime,
}
